/*
  Create Your Piece — step 02 · Piece (10.03 / 10.03b).
  Cards come from the sport's collection: one card per family present.
  Count-driven layout: one piece = a composition that confirms
  ("This is the one"), two or more = a grid that selects.
  A change of piece that the typed engraving cannot survive asks first.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  var WORDS = ['No', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];

  CYP.use(function (cyp) {
    var panel = cyp.root.querySelector('[data-pb-step="2"]');
    var grid = panel.querySelector('[data-piece-grid]');
    var single = panel.querySelector('[data-piece-single]');
    var empty = panel.querySelector('[data-piece-empty]');
    var cards = panel.querySelector('[data-piece-cards]');
    var sub = panel.querySelector('[data-piece-sub]');
    var next = panel.querySelector('[data-piece-next]');
    var builtFor = null;
    var tick = '<svg width="11" height="9" viewBox="0 0 11 9" aria-hidden="true"><path d="M1 4.5L4 7.5L10 1.5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

    function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function sized(src, w) { return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }

    function imgFor(s, fam) {
      var fe = cyp.finishEntry(Object.assign({}, s, { piece: fam }));
      if (!fe) return null;
      if (fe.optIndex >= 0) {
        for (var i = 0; i < fe.product.variants.length; i++) {
          var v = fe.product.variants[i];
          if (v.options[fe.optIndex] === fe.optValue && v.img) return v.img;
        }
      }
      return fe.product.img[0];
    }

    function build() {
      var s = cyp.state;
      var sp = cyp.sportBy(s.sport);
      var key = (sp ? sp.slug : '') + '|' + (s.finish || '');
      if (builtFor === key) return;
      builtFor = key;
      var legend = cards.querySelector('legend');
      cards.innerHTML = '';
      cards.appendChild(legend);
      if (!sp) return;
      var n = sp.pieces.length;
      sub.textContent = WORDS[n] + ' ' + sp.name + (n === 1 ? ' piece' : ' pieces') + '. Prices are the real starting prices; engraving is priced on step 04.';
      sp.pieces.forEach(function (pc, i) {
        var q = cyp.quote(Object.assign({}, s, { piece: pc.family, type: null }));
        var src = imgFor(s, pc.family);
        var id = 'pb-piece-' + i;
        var label = document.createElement('label');
        label.className = 'pb-card pb-opt';
        label.setAttribute('data-piece', pc.family);
        label.innerHTML =
          '<input class="pb-radio" type="radio" name="pb-piece" value="' + pc.family + '" aria-describedby="' + id + '-t ' + id + '-p">' +
          '<span class="pb-card__media">' + (src ? '<img src="' + esc(sized(src, 700)) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="pb-card__body">' +
            '<span class="pb-card__row">' +
              '<span class="pb-card__name">' + esc(pc.name) + '</span>' +
              '<span class="pb-card__tag" id="' + id + '-t">' + esc(cyp.settings.taglines[pc.family]) + '</span>' +
            '</span>' +
            '<span class="pb-card__price" id="' + id + '-p">' + (q ? cyp.money(q.base) : '') + '</span>' +
          '</span>' +
          '<span class="pb-check" aria-hidden="true">' + tick + '</span>';
        cards.appendChild(label);
      });
    }

    function render() {
      var s = cyp.state;
      var sp = cyp.sportBy(s.sport);
      build();
      var n = sp ? sp.pieces.length : 0;
      grid.hidden = n < 2;
      single.hidden = n !== 1;
      empty.hidden = n !== 0;
      if (n === 0) {
        panel.querySelector('[data-empty-sub]').textContent = sp
          ? 'We haven’t made a ' + sp.name + ' piece yet. Choose a different sport.'
          : 'Choose a sport first.';
      }
      if (n === 1) {
        var only = sp.pieces[0];
        var q = cyp.quote(Object.assign({}, s, { piece: only.family, type: null }));
        single.querySelector('[data-single-name]').textContent = only.name;
        var d = single.querySelector('[data-single-desc]');
        d.textContent = sp.single || '';
        d.hidden = !sp.single;
        single.querySelector('[data-single-price]').textContent = q ? cyp.money(q.base) : '';
      }
      cards.querySelectorAll('.pb-card').forEach(function (card) {
        var input = card.querySelector('input');
        input.checked = input.value === s.piece;
        card.classList.toggle('is-selected', input.checked);
      });
      next.setAttribute('aria-disabled', s.piece ? 'false' : 'true');
    }

    /* Personalization survives a change of piece unless the new piece
       cannot carry it; then ask first, never clear silently. */
    function choose(family) {
      var s = cyp.state;
      if (family === s.piece) return Promise.resolve(true);
      var tooLong = s.type === 'text' && s.value && s.value.length > cyp.limit(family);
      if (!tooLong) { cyp.set({ piece: family }); return Promise.resolve(true); }
      var sp = cyp.sportBy(s.sport), pc = null;
      sp.pieces.forEach(function (p) { if (p.family === family) pc = p; });
      var msg = 'The ' + pc.name + ' takes ' + WORDS[cyp.limit(family)].toLowerCase() + ' characters, so “' + s.value + '” would be cleared.';
      return cyp.confirm(msg, 'Switch and clear', 'Keep my piece').then(function (ok) {
        if (ok) cyp.set({ piece: family, value: '' });
        else render();
        return ok;
      });
    }

    function commit() {
      var s = cyp.state;
      if (!s.piece) return;
      var q = cyp.quote();
      cyp.track('product_selected', { sport: s.sport, product: q ? q.entry.product.handle : s.piece, price: q ? q.base / 100 : null });
      cyp.go('3');
    }

    panel.addEventListener('change', function (e) {
      if (e.target.name === 'pb-piece') choose(e.target.value);
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.name === 'pb-piece') { e.preventDefault(); commit(); }
    });
    next.addEventListener('click', commit);
    panel.querySelector('[data-single-next]').addEventListener('click', function () {
      var sp = cyp.sportBy(cyp.state.sport);
      if (!sp || sp.pieces.length !== 1) return;
      choose(sp.pieces[0].family).then(function (ok) { if (ok) commit(); });
    });

    cyp.on('state', render);
  });
})();
